import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { HttpService } from 'src/app/http.service';
import { SnackbarService } from 'src/app/snackbar.service';
import { ValidationService } from 'src/app/validation.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss']
})
export class FilterModalComponent implements OnInit {
  showLoader = false;
  carriersData;
  carriers = [];
  locations = [];
  units = [];
  ranges = ['Any', '5 KM', '10 KM',  '20 KM', '50 KM', '100 KM'];
  rangesSelect = [
    {
      id: 0,
      name: 'Any',
    },
    {
      id: 0.5,
      name: '500 M',
    },
    {
      id: 2.5,
      name: '2.5 KM',
    },
    {
      id: 5,
      name: '5 KM',
    },
    {
      id: 10,
      name: '10 KM',
    },
    {
      id: 20,
      name: '20 KM',
    },
    {
      id: 50,
      name: '50 KM',
    },
    {
      id: 100,
      name: '100 KM',
    }
  ]
  selectedCarrier;
  selectedRange;
  selectedUnitLocation = '';
  selectedFavLocation = '';
  organizations = [];
  selectedOrganisation;
  selectedLocation;

  constructor(private dialog: MatDialogRef<FilterModalComponent>, @Inject(MAT_DIALOG_DATA) private parentData: any,
  private http: HttpService, private snackbar: SnackbarService, private valid: ValidationService,
  private translate: TranslateService) { }

  ngOnInit(): void {
    // this.getCarriers();
    this.getOrganisations();
    this.getUnitLocations();
  }

  getCarriers() {
    this.http.get('carriers').subscribe((res: any) => {
      this.carriersData = res.data;
      this.carriers = this.carriersData.map(carrier => {
        return {
          id: carrier._id,
          name: carrier.parent_name
        }
      });
    }, (err:  any) => {
      this.snackbar.openSnackBar(err.error.message,'', 'err');
    })
  }

  getUnitLocations(filters:any = {}) {
    this.http.get('/shippers',filters).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          const totalLocs = response.data.length;
          if (totalLocs) {
            const locations = response.data;
            locations.forEach((element, index) => {
              const temp: any = {};
              temp.id = element._id;
              temp.sno = index + 1 || 0;
              temp.name = element.name;
              this.units.push(temp)
            });
          }
        }
      }
    );
  }

  getOrganisations() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.organizations = [];
          if (data.data.organizations.length) {
            const org = data.data.organizations;
            org.forEach(element => {
              const temp: any = {};
              temp.id = element._id;
              temp.name = element.name;
              this.organizations.push(temp);
            });
            this.selectedOrganisation = this.organizations[0];
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  onLocationChange(value, unit=true) {
    this.selectedLocation = value;
    if (unit) {
      this.selectedFavLocation = '';
    }else {
      this.selectedUnitLocation = '';
    }
  }
  applyFilters() {
    const data = {
      range: this.selectedRange,
      location: this.selectedLocation,
    }
    this.dialog.close(data);
  }

  closeDialog() {
    this.dialog.close();
  }
}
